export default __webpack_public_path__ + "static/media/metas-modelo.7be682bc.csv";